export function groupBy<K, V>(list: Array<V>, keyGetter: (input: V) => K): Map<K, Array<V>> {
  const map = new Map();
  list?.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (collection) {
      collection.push(item);
    } else {
      map.set(key, [item]);
    }
  });

  return map;
}

export const checkIsTypingActive = () => {
  return ['INPUT', 'TEXTAREA'].includes(document.activeElement?.tagName || '');
};

export const normalizeOptionalNumber = (value?: number | null | '') => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsedValue = Number(value);
  return Number.isNaN(parsedValue) ? null : parsedValue;
};

const BYTES_IN_GIGABYTE = 1024 * 1024 * 1024;

export const gigabytesToBytes = (value?: number | null | '') => {
  const normalized = normalizeOptionalNumber(value);

  if (normalized === null) {
    return null;
  }

  return Math.round(normalized * BYTES_IN_GIGABYTE);
};

export const bytesToGigabytes = (value?: number | null): number | '' => {
  if (value === null || value === undefined) {
    return '';
  }

  return Number((value / BYTES_IN_GIGABYTE).toFixed(2));
};
